<template>
      <div>
      <div class="swiper-container">
            <swiper :options="swiperOption">
            <swiper-slide class="slide-1 slide"></swiper-slide>
            <swiper-slide class="slide-2 slide"></swiper-slide>
            <swiper-slide class="slide-3 slide"></swiper-slide>
            <swiper-slide class="slide-4 slide"></swiper-slide>


            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
      </div>
      <div class="mobile-banner">
        <img src="~@/assets/img/index_img/mobile_banner.png" alt="">
      </div>
      </div>
</template>

<script>
  export default {
    mounted () {
      if(document.querySelector('.slide')){
        if(document.querySelectorAll('.slide').forEach){
           document.querySelectorAll('.slide').forEach((item) => {
            item.addEventListener('click',() => {
              this.$router.push('/Download')
            })
          })
        }
      }
      if(document.querySelector('.mobile-banner')){
        document.querySelector('.mobile-banner').addEventListener('click',() => {
          this.$router.push('/Download')
        })
      }
    },
    data() {
      return {
        swiperOption: {
          slidesPerView: 1,
          spaceBetween: 30,
          loop: true,
          autoplay: {
              disableOnInteraction: false,
              delay:2000
          },
          // autoplay : 2000,
          autoplayDisableOnInteraction: false,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  >>> .swiper-button-prev, .swiper-button-next
    height 100%
    width 100px
    margin-top -290px
  >>> .swiper-pagination-bullet
    transition all .3s ease-in
  >>> .swiper-pagination-bullet-active
    background: #007afc;
    width: 25px;
    border-radius: 30px;
  .mobile-banner
    display none
  .swiper-container {
    background-color: #000;
  }
  .swiper-slide {
    background-size: cover;
    background-position: center;
    height 580px
    &.slide-1 {
      background-size: cover;
      background-position: center;
      background-image:url('~@/assets/img/huasheng_banner1.jpg');
    }
    &.slide-2 {
      background-size: cover;
      background-position: center;
      background-image:url('~@/assets/img/huasheng_banner2.png');
    }
    &.slide-3 {
      background-size: cover;
      background-position: center;
      background-image:url('~@/assets/img/huasheng_banner3.jpg');
    }
    &.slide-4 {
      background-size: cover;
      background-position: center;
      background-image:url('~@/assets/img/huasheng_banner4.jpg');
    }
  }
  .gallery-top {
    height: 80%!important;
    width: 100%;
  }
  .gallery-thumbs {
    height: 20%!important;
    box-sizing: border-box;
    padding: 10px 0;
  }
  .gallery-thumbs .swiper-slide {
    width: 25%;
    height: 100%;
    opacity: 0.4;
  }
  .gallery-thumbs .swiper-slide-active {
    opacity: 1;
  }
  @media screen and (max-width: 768px)
    .swiper-slide
      height 375px
  @media screen and (max-width: 456px)
    .swiper-container
      display none
    .mobile-banner
      display block
    .mobile-banner img
      width 100%
      height 100%
    .swiper-slide
      height 200px
      background-size cover
    >>> .swiper-button-next,.swiper-button-prev
      width 20px
      height 20px
</style>



// WEBPACK FOOTER //
// src/pages/Home/components/banner.vue